/* eslint-disable no-unused-vars */
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Popconfirm, Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { AiOutlineCheckCircle, AiOutlineMinusCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { ReactComponent as Trash } from "../../../../assets/images/svgs/trash.svg";
import { getRoutingConfig } from "../../../../store/actions/manager.action";
import {
  commissionType,
  deliveryMethod,
} from "../../../../utils/helpers/objectHelpers";
import { ManagerService } from "../../../../utils/services/manager.service";

function Body({
  domainBrand,
  countries,
  currencies,
  routeConfigs,
  paycenters,
}) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");
  const { Column } = Table;
  const dispatch = useDispatch();

  const [country, setCountry] = useState({});
  const [bankCode, setBankCode] = useState("");
  const [chargeCurrency, setChargeCurrency] = useState({});
  const [currencyFrom, setCurrencyFrom] = useState({});
  const [receivingCurrency, setReceivingCurrency] = useState({});
  const [chargeType, setChargeType] = useState({});
  const [chargeAmount, setChargeAmount] = useState("");
  const [maxAmount, setMaxAMount] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [delivery, seDeliveryMethod] = useState({});
  const [autoRoute, setAutoRoute] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow([...selectedRows]);
    },
  };

  const tableData = routeConfigs?.map((i, index) => {
    return { ...i, key: index };
  });

  const AddAutomaticRouting = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.automaticRouting(
        payload,
        "password"
      );

      if (response.data.status === "SUCCESS") {
        setLoading(false);
        toast.success("Route successfully applied");
        dispatch(getRoutingConfig());
      } else {
        toast.error("Couldn't apply route, pls try again");
      }
    } catch (error) {
      setLoading(false);
      toast.success(error?.response?.data?.message);
      return error;
    }
    setLoading(false);
  };

  const payload = {
    transactionType: delivery?.value,
    currencyFrom: currencyFrom?.currencyCode,
    isoCountryCode3: country?.iso3Code,
    routeToApiPayCenterId: autoRoute?.id,
    receivingCurrency: receivingCurrency?.currencyCode,
    fromAmount: parseFloat(minAmount),
    toAmount: parseFloat(maxAmount),
    settlementCurreny: receivingCurrency?.currencyCode,
    bankCode: bankCode,
    chargeType: chargeType?.value,
    chargeAmount: parseInt(chargeAmount),
    chargeCurreny: chargeCurrency?.currencyCode,
    applyCharge: true,
  };

  const deleteRoute = async (apiId) => {
    setConfirmLoading(true);
    try {
      const response = await ManagerService.deleteRoute(apiId);

      if (response.status === 200) {
        toast.success(response.data.message);
        setConfirmLoading(false);
        dispatch(getRoutingConfig());
      }
    } catch (error) {
      setConfirmLoading(false);
      return error;
    }
    setConfirmLoading(false);
  };

  const changeRouteStatus = async (apiId) => {
    setConfirmLoading(true);
    try {
      const response = await ManagerService.changeRouteStatus(apiId);

      if (response.status === 200) {
        toast.success(response.data.message);
        setConfirmLoading(false);
        dispatch(getRoutingConfig());
      }
    } catch (error) {
      setConfirmLoading(false);
      return error;
    }
    setConfirmLoading(false);
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_AUTOMATIC_ROUTIN_41973742"]
                : "Automatic Routing"}
            </h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                {dictionary
                  ? dictionary[
                      "para_you_can_default_any_transaction_types_to_a_preferred_paycenter_from_here"
                    ]
                  : `You can route any transaction to a preferred Paycenter/API for Payout`}
              </li>
            </ol>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["para_destination_country"]
                        : `
                    Destination Country`}
                    </label>
                    <Select
                      options={countries}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={country}
                      name="pcnFor"
                      onChange={(option) => {
                        setCountry(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      Bank Code(Optional: Bank code of beneficiary bank account)
                    </label>
                    <input
                      type={"text"}
                      className="form-control"
                      value={bankCode}
                      onChange={(e) => setBankCode(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>CHARGE CURRENCY</label>
                    <Select
                      options={currencies}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={chargeCurrency}
                      name="pcnFor"
                      onChange={(option) => {
                        setChargeCurrency(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>CHARGE TYPE</label>
                    <Select
                      options={commissionType}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={chargeType}
                      name="pcnFor"
                      onChange={(option) => {
                        setChargeType(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>CHARGE AMOUNT</label>
                    <input
                      type={"text"}
                      className="form-control"
                      value={chargeAmount}
                      onChange={(e) => setChargeAmount(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["para_currency_from"]
                        : "Currency From"}
                    </label>
                    <Select
                      options={currencies}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={currencyFrom}
                      name="pcnFor"
                      onChange={(option) => {
                        setCurrencyFrom(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["para_receiving_currency"]
                        : "Receiving Currency"}
                    </label>
                    <Select
                      options={currencies}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={receivingCurrency}
                      name="pcnFor"
                      onChange={(option) => {
                        setReceivingCurrency(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["para_delivery_method"]
                        : `
                    Delivery Method`}
                    </label>
                    <Select
                      options={deliveryMethod()}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={delivery}
                      name="pcnFor"
                      onChange={(option) => {
                        seDeliveryMethod(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["WO_AMOUNT_FRO_1243490620"]
                        : `
                    Minimum Amount`}
                    </label>
                    <input
                      type={"text"}
                      className="form-control"
                      value={minAmount}
                      onChange={(e) => setMinAmount(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["WO_MAXIMUM_AMOUN_-1198115106"]
                        : `
                    Maximum Amount`}
                    </label>
                    <input
                      type={"text"}
                      className="form-control"
                      value={maxAmount}
                      onChange={(e) => setMaxAMount(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary
                        ? dictionary["WO_PROCESSING_AGENTPAR_-895513135"]
                        : "Auto route to an Agent/Branch/Partner API for processing"}
                    </label>
                    <Select
                      options={paycenters}
                      getOptionLabel={(option) => option?.name}
                      getOptionValue={(option) => option?.id}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={autoRoute}
                      name="pcnFor"
                      onChange={(option) => {
                        setAutoRoute(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <button
                      className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center text-capitalize"
                      type="button"
                      onClick={() => AddAutomaticRouting(payload)}
                    >
                      {dictionary
                        ? dictionary["WO_ROUTE_TRANSACTIONS_1208928746"]
                        : "Apply Routing"}
                      {loading && (
                        <>
                          &nbsp;&nbsp;
                          <i className="fa fa-spinner fa-spin" />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="table-responsive">
              <Table
                dataSource={tableData}
                className="w-100 table tbody"
                loading={loading}
                rowSelection={rowSelection}
              >
                <Column
                  title="Created Date"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />
                <Column
                  title="Status"
                  dataIndex="status"
                  key="2"
                  className=""
                />
                <Column
                  title="Country"
                  dataIndex="commonName"
                  key="3"
                  className=""
                />
                <Column
                  title="Processor"
                  dataIndex="processor"
                  key="4"
                  className=""
                />
                <Column
                  title="Currency"
                  dataIndex="currencyFrom"
                  key="5"
                  className=""
                  render={(text, record) => {
                    return (
                      <span>
                        {record.currencyFrom}/{record.settlementCurreny}
                      </span>
                    );
                  }}
                />
                <Column
                  title="Min Amount"
                  dataIndex="fromAmount"
                  key="6"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Max Amount"
                  dataIndex="toAmount"
                  key="7"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Delivery Method"
                  dataIndex="transactionType"
                  key="8"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Bank Code"
                  dataIndex="bankCode"
                  key="9"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Charge Currency"
                  dataIndex="chargeCurreny"
                  key="9"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Charge Type"
                  dataIndex="chargeType"
                  key="9"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Charge Amount"
                  dataIndex="chargeAmount"
                  key="9"
                  className=""
                  render={(text) => {
                    return <span>{text}</span>;
                  }}
                />
                <Column
                  title="Action"
                  dataIndex="action"
                  key="9"
                  className=""
                  render={(text, record) => {
                    return (
                      <space size="large">
                        <Popconfirm
                          title={`Delete ${record.transactionType}`}
                          description="Are you sure want to delete this route?"
                          icon={
                            <QuestionCircleOutlined style={{ color: "red" }} />
                          }
                          onConfirm={() => deleteRoute(record.id)}
                          okButtonProps={{
                            loading: confirmLoading,
                            style: { width: "100px" },
                          }}
                          onCancel={() => {
                            setConfirmLoading(false);
                          }}
                          okText={"Delete"}
                        >
                          <Tooltip
                            title={`Delete ${record.transactionType}`}
                            color="#212529"
                            placement="bottom"
                            arrowPointAtCenter={true}
                          >
                            <Trash className="cursor-pointer" />
                          </Tooltip>
                        </Popconfirm>

                        <Popconfirm
                          title={`Deactivate ${record.transactionType}`}
                          description="Are you sure want to deactivate this route?"
                          icon={
                            <QuestionCircleOutlined style={{ color: "red" }} />
                          }
                          onConfirm={() => changeRouteStatus(record.id)}
                          okButtonProps={{
                            loading: confirmLoading,
                            style: { width: "100px" },
                          }}
                          onCancel={() => {
                            setConfirmLoading(false);
                          }}
                          okText={"Deactivate"}
                        >
                          <Tooltip
                            title={`Deactivate ${record.transactionType}`}
                            color="#212529"
                            placement="bottom"
                            arrowPointAtCenter={true}
                          >
                            <AiOutlineMinusCircle
                              color={"#6259CA"}
                              fontSize={23}
                              className="cursor-pointer"
                            />
                          </Tooltip>
                        </Popconfirm>
                      </space>
                    );
                  }}
                />
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
